import { render } from "./NewsSearch.vue?vue&type=template&id=8f19dbec&scoped=true"
import script from "./NewsSearch.vue?vue&type=script&lang=js"
export * from "./NewsSearch.vue?vue&type=script&lang=js"

import "./NewsSearch.vue?vue&type=style&index=0&id=8f19dbec&scoped=true&lang=less"

import exportComponent from "D:\\workCode\\cbc\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f19dbec"]])

export default __exports__